<div class="content with-vertical-padding"
  *transloco="let t; read: 'sl-page-not-found'">
  <div class="message-wrapper">
    <h1 class="mat-display-4">{{ t('title') }}</h1>
    <div class="mat-display-2">{{ t('subtitle') }}</div>

    <nav role="navigation">
      <ul>
        <li>
          <a [href]="'https://help.accredible.com'"
            [attr.aria-label]="t('aria_help')"
            target="_blank">{{ t('help') }}</a>
        </li>
      </ul>
    </nav>
  </div>

  <div class="image-wrapper">
    <img src="assets/images/404-error.png"
      alt="">
  </div>
</div>
